import { useContext } from 'react';

import { Box } from '@zillow/constellation-10';
import { ErrorPage as ErrorPageComponent } from '@zg-rentals/error-page-components';

import HeadWrapper from '../../components/HeadWrapper';

import ErrorMessageConstants, { ERROR_PAGE_TYPES } from '../../constants/ErrorMessageConstants';

import { RMWContext } from '../../providers/RMWContext';
import { RoutingSelectors } from '../../selectors';
import { useSelector } from '../../selectors/useSelector';

const ERROR_CONFIG = {
  [ERROR_PAGE_TYPES.NOT_FOUND]: {
    title: 'Page not found',
    message: 'Page not found',
    details: '',
  },
  [ERROR_PAGE_TYPES.TECHNICAL_DIFFICULTIES]: {
    title: 'Technical difficulties',
    message: 'Something went wrong',
    details: ErrorMessageConstants.TECHNICAL_DIFFICULTIES,
  },
  [ERROR_PAGE_TYPES.UNAUTHORIZED]: {
    title: 'Unauthorized',
    message: 'Something went wrong',
    details: ErrorMessageConstants.LISTING_NO_PERMISSION,
  },
  [ERROR_PAGE_TYPES.PREMIUM_ANALYTICS_ERROR]: {
    title: 'Technical difficulties',
    message: 'Something went wrong',
    details: 'We are having trouble loading your data. Try reloading the page or come back later.',
  },
};

const ErrorPage = ({
  type = ERROR_PAGE_TYPES.NOT_FOUND,
}: {
  type?: (typeof ERROR_PAGE_TYPES)[keyof typeof ERROR_PAGE_TYPES];
}) => {
  const { paths } = useContext(RMWContext);
  const listingId = useSelector((state) => RoutingSelectors.makeListingId(state));

  const { title, message, details } = ERROR_CONFIG[type];

  return (
    <Box data-testid={`${type}-page`}>
      <HeadWrapper title={title} />
      <ErrorPageComponent
        errorMessage={message}
        errorDetails={details}
        action={
          type === ERROR_PAGE_TYPES.PREMIUM_ANALYTICS_ERROR ? (
            <a href={`${paths.propertiesPage}/${listingId}/listing`}>Return to your property</a>
          ) : (
            <a href="https://www.zillow.com/rental-manager">Return to Zillow Rental Manager</a>
          )
        }
      />
    </Box>
  );
};

export default ErrorPage;
